import { render, staticRenderFns } from "./sTaxLibrary.vue?vue&type=template&id=79618661&scoped=true&"
import script from "./sTaxLibrary.vue?vue&type=script&lang=js&"
export * from "./sTaxLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79618661",
  null
  
)

export default component.exports